module.exports = "https://cdn.dove.it/_next/static/public/assets/channels/logo-casa.it.449508d25da841c185206a893f84fb43.png";